<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      :show-save-button="false"
      unit="供应商"
      :edit-title="status"
      id-key="UserId"
      :get-data-func="api.list"
      @opened="onOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <el-table
        ref="list"
        :data="tableData"
        @cell-click="cellClick"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          prop="Suppliers"
          label="供应商"
          min-width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <!-- <el-select v-model="row.TradeUnitId"></el-select> -->
            <el-select v-model="row.TradeUnitId" filterable :disabled="!status" >
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :value="item.TradeUnitId"
                :label="getLabel(item)"
                @click.native="changTradUnit(item,row)"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="qua" label="数量" min-width="120" align="center">
          <template slot-scope="{ row }">
            <el-input
              type="number"
              v-model.number="row.PurchaseQuantity"
              v-if="status"
              @change="changePurchaseQuantity(row)"
            ></el-input>
            <span v-else>{{row.PurchaseQuantity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="del(row, $index)"
              :disabled="!status"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      index: 0,
      tableData: [],
      api: require("@/api/ba/tradeUnit").default,
      // api: require("@/api/sy/user").default,
      tradeUnitList: [],
      delTableData: [],
    };
  },
  props: {
    status: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    getLabel(item){
      return item.FullName + `(${item.TradeUnitNo})`
    },
    changePurchaseQuantity(row){
      if(row.T !== 0){
        row.T = 1;
      }
    },
    onOpened(row) {
      console.log('row',row);
      this.index = row.index;
      // 选择供应商
      this.api.list({TradeUnitTypes:[1,2]}).then((res) => {
        if (res.Code === 0){
          this.tradeUnitList = res.Data
          if(row.TradeUnitModels?.length !=0 ) this.tableData = row.TradeUnitModels;
          console.log('sup tableData', this.tableData)
        };

        // console.log("默认供应商");
        // console.log(this.tradeUnitList);
      });

      this.addColumn(row);
    },
    changTradUnit(data,row){

      if(this.tableData.filter(i=>i.TradeUnitId === data.TradeUnitId).length > 1){
        row.TradeUnitId  = null
        return this.$message.warning("供应商已存在")
      }
      row.TradeUnitNo = data.TradeUnitNo
      row.ShortName =  data.ShortName
      row.TradeUnitName = data.FullName
      if(row.T !== 0){
        row.T = 1;
      }
    },
    addColumn(row = {}) {
      let num =
        row.Quantity && row.Quantity > 0
          ? row.Quantity
          : 0;
      if (this.tableData.length > 0) num = 0;
      this.tableData.push({
        T: 0,
        PurchaseDemandTradeUnitId: 0,
        // PurchaseDemandDetailId: 0,
        // PurchaseDemandId: 0,
        TradeUnitId: row.TradeUnitId || null,
        // ProductId: 0,
        PurchaseQuantity: num,
        TradeUnitNo: row.SupplierNo || "",
        ShortName: "",
        TradeUnitName: row.SupplierName || "",
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // _open(row) {
    //   console.log('row',row);
    //   // this.tableData = [];
    //   // this.tradeUnitApi.list({ TradeUnitType: 1 }).then((res) => {
    //   //   if (res.Code == 0)  this.tableData = res.Data;
    //   //   // console.log("默认供应商");
    //   //   // console.log(this.tradeUnitList);
    //   // });

    //   this.addColumn();

    //   this.open().then(() => {
    //     this.addColumn(row);
    //     //   if(row.suppliers.length === 0){
    //     //     let o = {
    //     //       Suppliers: '',
    //     //       qua: '',
    //     //     }
    //     //      this.tableData.push(o);
    //     //   }else{
    //     //       let data = row.suppliers.map(v => {
    //     //         return {
    //     //           Suppliers: v.suppliersName,
    //     //           qua: '',
    //     //         }
    //     //       })
    //     //       this.tableData = data;
    //     //   }
    //   });
    // },
    del(row, index) {
      if(row.T !== 0){
        row.T = 2;
        this.delTableData.push(row)
      }
      this.tableData.splice(index, 1);
      if (this.tableData.length === 0) {
        this.addColumn();
      }
    },
    cellClick(row, col) {
      if(!this.status){
        return
      }
      if (
        (col.label === "数量" || col.label === "供应商") &&
        row.index === this.tableData.length - 1
      ) {
        this.addColumn();
      }
    },
    save() {
      const PurchaseQuantity =  Number(this.$parent.tableData[this.index].PurchaseQuantity)

      const Quantity = this.tableData.reduce((prev,curr) => {
        return prev + curr
      })

      console.log('PurchaseQuantity',PurchaseQuantity);
      console.log('Quantity',Quantity);
      if(Quantity < PurchaseQuantity) return this.$message.warning("采购量不能小于采购数量")
      // console.log('data',data); 
      // console.log('data',this.tableData);

      let tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData = tableData.concat(this.delTableData)

      const data = tableData.filter(item=>item.TradeUnitId != null)

      this.$emit("setData", { Data: data, index: this.index });
      this.close(true)
    },
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>
